module.exports = __webpack_public_path__ + "static/media/city4.60634605.jpg";